<ui-page-header>Produktinformationen</ui-page-header>

<ui-lmiv-product-search [searchText]="searchText()"></ui-lmiv-product-search>

@if (productResource.isLoading()) {
  <ui-lmiv-product-skeleton></ui-lmiv-product-skeleton>
} @else if (productResource.error() || productNotFound()) {
  <div class="section-wrapper">
    <ui-lmiv-product-not-found></ui-lmiv-product-not-found>
  </div>
} @else if (productModel(); as productData) {
  <div class="section-wrapper">
    <ui-product-detail-header
      [detailsDataScrollElement]="productDetailInfoComponent.headline?.nativeElement"
      [product]="productData"
      [showProductLabels]="false"
      [showProductInformationOnly]="true"
    ></ui-product-detail-header>
  </div>

  @let productDescription = productData.details.description?.trim();

  @if (productDescription) {
    <div class="section-wrapper">
      <div class="product-description">
        <h6>Produktbeschreibung</h6>
        <p>{{ productDescription }}</p>
      </div>
    </div>
  }

  <div class="section-wrapper">
    <ui-product-detail-info
      #productDetailInfoComponent
      [product]="productData">
    </ui-product-detail-info>
  </div>
}
